import { Body1 } from '@cian/ui-kit';
import { IconActionFilters16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { MAINPAGE_SEARCH_URL } from 'shared/constants/constants';
import { useTypewriterPlaceholder } from 'shared/components/RedesignSearchBox/useTypewriterPlaceholder';

import * as styles from './RentDailySearchBox.css';

export interface IRentDailySearchBoxProps {
  filtersUrl: string;
  onSearchClick(event: React.MouseEvent<HTMLAnchorElement>): void;
  onFiltersClick?(event: React.MouseEvent<HTMLAnchorElement>): void;
  placeholders: string[];
  disablePlaceholder: boolean;
  /** Текст поискового запроса. Если задан, показывается вместо плейсхолдера, а перебор не идёт. */
  searchQuery?: string;
}

const PLACEHOLDER = 'Что ищете?';

/**
 * Поисковая строка посуточной выдачи: всегда свёрнутый серый вид, без анимаций скролла.
 */
export const RentDailySearchBox: React.FC<IRentDailySearchBoxProps> = ({
  filtersUrl,
  onSearchClick,
  onFiltersClick,
  placeholders,
  disablePlaceholder = false,
  searchQuery,
}) => {
  const typedPlaceholder = useTypewriterPlaceholder(placeholders, disablePlaceholder || Boolean(searchQuery));

  const typedText = searchQuery ?? typedPlaceholder ?? PLACEHOLDER;
  const staticText = searchQuery ?? PLACEHOLDER;
  // Запрос пользователя — это контент, а не подсказка, поэтому он в основном цвете текста.
  const textColor = searchQuery ? 'text-primary-default' : 'text-secondary-default';

  return (
    <div className={styles['search-box']} data-testid="RedesignSearchBox">
      <a href={MAINPAGE_SEARCH_URL} className={styles['search-field']} onClick={onSearchClick} aria-label={staticText}>
        {/*
          Набирающийся текст скрыт от скринридера: он менял бы доступное имя ссылки
          на каждый символ. Вместо него имя задано статичным aria-label выше.
        */}
        <span className={styles['placeholder']} aria-hidden="true">
          <Body1 color={textColor}>{typedText}</Body1>
        </span>
      </a>
      <a
        href={filtersUrl}
        className={styles['filters-button']}
        onClick={onFiltersClick}
        data-testid="RedesignSearchBoxFiltersButton"
        aria-label="Фильтры"
      >
        <IconActionFilters16 />
      </a>
    </div>
  );
};

RentDailySearchBox.displayName = 'RentDailySearchBox';
